import { matchesPath } from '../matchesPath';

export const matchesProjects = matchesPath<{ projectId: string }>(/\/projects/);
